// Filter persistence for Solicitações (/solicitacoes). See usePersistedFilters.

export var SOLICITATIONS_FILTERS_KEY = 'solicitacoes';

export var getDefaultSolicitationsFilters = function() {
  return {
    statusFilter: 'pending',
    filter: '',
  };
};

// Badge: only what differs from the defaults.
export var countActiveSolicitationsFilters = function(filters, defaults) {
  var base = defaults || getDefaultSolicitationsFilters();
  return (filters.statusFilter !== base.statusFilter ? 1 : 0) + (filters.filter ? 1 : 0);
};
